import React, { useRef, useEffect, useState } from "react";
import {
  HeadlineImageWrapper,
  ImageWrapper,
  HeadlineImageContainer,
  HeadlineImage,
  BodyHeadlineContainer,
  BodyHeadline,
  ImageContainer,
  Image,
} from "../styles/components/body";
import animations from "../animations/animations";
import { BREAKPOINTS } from "../styles/variables/breakpoints";

const BodyHeadlineComponent = ({ articleData, bodyItems }) => {
  const [hasMounted, setHasMounted] = useState(false);
  const wrapperRef = useRef(null);
  const headlineImageWrapperRef = useRef(null);
  const headlineImageRef = useRef(null);
  const headlineWrapperRef = useRef(null);
  const headlineRef = useRef(null);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (
      !headlineImageRef.current |
        !headlineImageWrapperRef.current |
        !headlineRef.current ||
      !headlineImageRef.current ||
      typeof window === "undefined" ||
      !hasMounted
    )
      return;

    const mm = animations.matchMedia();

    setTimeout(() => {
      const headlineImageBox = headlineWrapperRef.current?.querySelector(
        ".headline-image-landing"
      );

      if (!headlineImageBox) return;

      const headlineImageBoxDimensions = headlineImageBox?.getBoundingClientRect();
      const wrapperDimensions = wrapperRef.current?.getBoundingClientRect();
      const { top, left, width, height } = headlineImageBoxDimensions || {};

      const masterTimeline = animations.timeline({
        scrollTrigger: {
          trigger: headlineImageWrapperRef.current,
          start: "top top",
          end: "bottom center-=500px",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });

      mm.add(`(min-width: ${BREAKPOINTS.md}px)`, () => {
        animations.set(headlineImageRef.current, {
          xPercent: 50,
          filter: "blur(10px)",
        });

        masterTimeline.to(headlineImageRef.current, {
          top: `${top - wrapperDimensions.top - height / 2.5}px`,
          left: `${left - width / 2}px`,
          width: `${width * 1.5}px`,
          transform: "translate3d(0,0,0)",
          filter: "blur(0px)",
        });

        const timeline = animations.timeline({
          scrollTrigger: {
            trigger: headlineRef.current,
            start: "top top",
            end: "bottom center",
            scrub: true,
            invalidateOnRefresh: true,
          },
        });

        timeline.to(headlineImageRef.current, {
          transform: "translate3d(0,0,0)",
          filter: "blur(10px)",
        });
      });

      animations.ScrollTrigger.refresh();
    }, 1000);

    return () => {
      mm.revert();
    };
  }, [hasMounted]);

  return (
    <HeadlineImageWrapper ref={wrapperRef}>
      {bodyItems &&
        bodyItems?.map((component, i) => {
          if (
            component.__typename === "DatoCmsHeadline" &&
            bodyItems[i + 1]?.moduleTitle === "component--body-headline-logo"
          ) {
            const imageComponent = bodyItems[i + 1];

            return (
              <BodyHeadlineContainer
                key={`headline-image-${i}`}
                ref={headlineWrapperRef}
                $primaryColor={articleData?.colors?.primary}
              >
                <BodyHeadline
                  ref={headlineRef}
                  $fontColor={articleData?.colors?.secondary}
                  suppressHydrationWarning={true}
                  dangerouslySetInnerHTML={{ __html: component.text }}
                />
                <ImageContainer>
                  <Image
                    src={imageComponent.images[0]?.image?.fluid?.src}
                    $logo
                  />
                </ImageContainer>
              </BodyHeadlineContainer>
            );
          }

          if (
            component.__typename === "DatoCmsImage" &&
            bodyItems[i - 1]?.moduleTitle === "component--body-headline-logo"
          ) {
            return null;
          }

          if (component.moduleTitle === "component--body-headline-image") {
            return (
              <ImageWrapper key={i} ref={headlineImageWrapperRef}>
                <HeadlineImageContainer
                  ref={headlineImageRef}
                  $primaryColor={articleData?.colors?.primary}
                >
                  <HeadlineImage src={component.images[0]?.image?.fluid?.src} />
                </HeadlineImageContainer>
              </ImageWrapper>
            );
          }
          return null;
        })}
    </HeadlineImageWrapper>
  );
};

export default BodyHeadlineComponent;
